import { render, staticRenderFns } from "./documents-list-manual.vue?vue&type=template&id=6b3ab82a&scoped=true"
import script from "./documents-list-manual.vue?vue&type=script&lang=js"
export * from "./documents-list-manual.vue?vue&type=script&lang=js"
import style0 from "./documents-list-manual.vue?vue&type=style&index=0&id=6b3ab82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ab82a",
  null
  
)

export default component.exports